<pinch-zoom backgroundColor="rgba(0,0,0,0)" [double-tap-scale]="3" disableZoomControl="never">
  <div [innerHTML]="content"></div>
</pinch-zoom>
